import React from 'react'

export const SubText: React.FC<any> = ({ children }) => {
  return (
    <div style={{ marginTop: '15%' }} className="pt-5 px-5 text-center">
      <hr />
      <small className="text-muted">{children}</small>
    </div>
  )
}
